import { render, staticRenderFns } from "./OpenCloseProposalListFilter.vue?vue&type=template&id=3825c492&"
import script from "./OpenCloseProposalListFilter.vue?vue&type=script&lang=js&"
export * from "./OpenCloseProposalListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports